import { get } from 'lodash';
import {
    GridColDef,
    GridValidRowModel,
    GridValueGetter,
} from '@mui/x-data-grid';
import { GridValueGetter as GridValueGetterPremium } from '@mui/x-data-grid-premium';
import { GridApiCommunity } from '@mui/x-data-grid/internals';

export * from './DataGrid';
export * from './DataGridCard';

export const dataGridNestedObjectValueGetter = <
    R extends GridValidRowModel = GridValidRowModel,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    V = any,
    F = V,
    TValue = never,
>(
    value: TValue,
    row: R,
    column: GridColDef<R, V, F>,
    apiRef: React.MutableRefObject<GridApiCommunity>
): GridValueGetter<R, V, F, TValue> => {
    return get(row, column.field);
};

export const treeGridNestedObjectValueGetter = <
    R extends GridValidRowModel = GridValidRowModel,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    V = any,
    F = V,
    TValue = never,
>(
    value: TValue,
    row: R,
    column: GridColDef<R, V, F>,
    apiRef: React.MutableRefObject<GridApiCommunity>
): GridValueGetterPremium<R, V, F, TValue> => {
    return get(row, column.field);
};
